import React from 'react';

const Schedule = () => {
  const events = [
    { time: "08:00", event: "Check-in & Registrations Open", location: "Clubhouse" },
    { time: "09:30", event: "Skippers' Briefing", location: "Main Dock" },
    { time: "10:25", event: "Warning Signal (Race 1)", location: "Sound" },
    { time: "11:00", event: "First Start", location: "Start Line A" },
    { time: "13:00", event: "Lunch Break", location: "On-water / Clubhouse" },
    { time: "15:30", event: "Final Race of the Day", location: "Start Line B" },
    { time: "17:30", event: "Awards Ceremony", location: "Grand Marquee" },
  ];

  return (
    <div className="schedule-section">
      <h3>Event Schedule</h3>
      <div className="timeline">
        {events.map((item, index) => (
          <div key={index} className="timeline-item">
            <div className="timeline-time">{item.time}</div>
            <div className="timeline-content">
              <h4>{item.event}</h4>
              <p>📍 {item.location}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Schedule;
